import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import {eye} from 'react-icons-kit/icomoon/eye';
import SvgIcon from 'react-icons-kit';
import moment from 'moment';
import Help from '../generics/help';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import ModalNotes from '../offers/modalNotes';
import {pencil} from 'react-icons-kit/icomoon/pencil';

var Config = require('../../config');

class SampleSearch extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.donationNotes = this.donationNotes.bind(this);

		this.state = {
			sample_id:"",
			sample:{},
			columns:[],
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=SAMPLE_SEARCH',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		});
	}

	onSearch(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'samples/sample_search?sample_id='+this.state.sample_id+
			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			return res.json();
			
		}).then(response =>{
			if(response.donation_number !== undefined){
				this.setState({sample:response, sample_id:""});
			}else{
				swal('Error', 'Registro no encontrado', 'error');
			}
		})
	}

	viewInfo(sample, donation, group, change){
		if(change){
			this.props.history.push({
				pathname: 'results_donation/edit/'+sample+'/'+donation+'/'+group,
				state: { 
				    from: '/sample_search',
				    force: true
				}
			});
		}else{
			this.props.history.push({
				pathname:'results_donation/edit/'+sample+'/'+donation+'/'+group,
				state:{
					from: '/sample_search',
					view: true
				}
			});
		}
		
	}

	donationNotes(){
		this.modal_notes.handleShow(this.state.sample.donor_id, true);
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
					    {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.laboratory.MAIN')} ->
						{t('sidebar.nav.laboratory.sample_search')}
					</h5>
				</div>
				
				<Help
					{...this.props} 
	              	menu={"help_laboratory"} 
	              	submenu={"help_search_samples"}  />
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">No. Muestra/ No. Donación</span>
						<input type="text" name="sample_id" id="sample_id" value={this.state.sample_id || ""} 
							onKeyPress={(e)=>
								e.key === 'Enter' &&
									this.onSearch()								
							}
							onChange={this.handleChange} className="form-control" autoComplete="off"/>
					</div>
					<div className="col-xs-12 col-sm-1" style={{marginTop:"11px"}}>
						<button type="button" className="btn btn-info" style={{fontSize:"1em"}}
							onClick={this.onSearch}>
							{t('content.generics.buttons.search')}
						</button>
					</div>
				</div>
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={this.showColumn('DONATION_NUMBER')}>No. Donación</th>
								<th hidden={this.showColumn('DONATION_DATE')}>Fecha Donación</th>
								<th hidden={this.showColumn('DONOR')}>Donador</th>
								<th hidden={this.showColumn('CONTROLS')}></th>
							</tr>
						</thead>
						<tbody>
							{this.state.sample.donation_number !== undefined ?
								<tr>
									<td hidden={this.showColumn('DONATION_NUMBER')}>{this.state.sample.donation_number}</td>
									<td hidden={this.showColumn('DONATION_DATE')}>
										{moment(this.state.sample.donation_date).format('DD/MM/YYYY')+' '}
										{moment(this.state.sample.donation_hour, 'h:mm').format('h:mm a')}
									</td>
									<td hidden={this.showColumn('DONOR')}>
										{this.state.sample.donor_name}
										{this.state.sample.has_notes ?
											<SvgIcon size={15} icon={pencilSquareO} style={{cursor:'pointer', marginLeft:'8px'}}
												onClick={(e) => this.donationNotes(e)}/>
											
										:null}
									</td>
									<td hidden={this.showColumn('CONTROLS')}>
										{this.props.task_has_user_profiles !== null ?
									    	this.props.task_has_user_profiles.map((user)=>{
										    	return user !== undefined ?
										    		user === 'CHANGE_SAMPLE_RESULTS' ?
														<button className="btn btn-info" title="Cambiar Resultados" type="button" 
															disabled={this.state.sample.sample_id === 0}
															onClick={this.viewInfo.bind(this, this.state.sample.sample_id, 
																this.state.sample.donation_id, this.state.sample.group_test_id, true)}>
									                        <SvgIcon icon={pencil}/>
									                     </button>
													:null
										    	:null
										    })
									    :null}
										<button className="btn btn-info" title="Ver" type="button" 
											disabled={this.state.sample.sample_id === 0}
											style={{marginLeft:'8px'}}
											onClick={this.viewInfo.bind(this, this.state.sample.sample_id, 
												this.state.sample.donation_id, this.state.sample.group_test_id, false)}>
					                        <SvgIcon icon={eye}/>
					                     </button>
									</td>
								</tr>
							:null}
						</tbody>
					</Table>
				</div>

				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)}  />
			</div>
		)
	
	}
}

export default translate('translations') (SampleSearch);